// extracted by mini-css-extract-plugin
export default {"video":"dhbrm__video--d8066"};